// extracted by mini-css-extract-plugin
export var closeButton = "_2k-3";
export var header = "_2k-0";
export var link = "_2k-1";
export var retryButton = "_2k-2";